module.exports = __webpack_public_path__ + "img/icon-sun-cloud.83766986.png";